import WsProvider from './provider/WSProvider'

var serviceName = "webservis";
var moduleName = "dashboard";


var analitikService = {
    dashboardData() {
        var userDataDemirag = localStorage.getItem("userDataDemirag")
        var param = {
            token: userDataDemirag,
            serviceName: moduleName,
            methodName: "listele"
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
    yaklasanProjeler(tur, gun) {
        var userDataDemirag = localStorage.getItem("userDataDemirag")
        var param = {
            token: userDataDemirag,
            serviceName: 'proje',
            methodName: "yaklasanProjeler",
            ['data[tur]']: tur,
            ['data[gun]']: gun,
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
}


export default analitikService